import { useEffect } from 'react'
import type { LatLng, LeafletMouseEventHandlerFn } from 'leaflet'
import type { MapRef } from '../LeafletMap'

export type MoveHandler = (newCenter: LatLng) => void
export type ZoomHandler = (newZoom: number) => void

interface Events {
  onClick?: LeafletMouseEventHandlerFn
  onMove?: MoveHandler
  onZoom?: ZoomHandler
  zoom?: number
}

const useEvents = (mapRef: MapRef, { onClick, onMove, onZoom, zoom }: Events) => {
  useEffect(() => {
    if (zoom) {
      mapRef.current?.setZoom(zoom)
    }
  }, [zoom])

  useEffect(() => {
    if (onMove && mapRef.current) {
      const handler = () => {
        if (mapRef.current) {
          onMove(mapRef.current.getCenter())
        }
      }

      mapRef.current.on('moveend', handler)

      return () => {
        mapRef.current?.off('moveend', handler)
      }
    }

    return () => undefined
  }, [onMove])

  useEffect(() => {
    if (onZoom && mapRef.current) {
      const handler = () => {
        if (mapRef.current) {
          onZoom(mapRef.current.getZoom())
        }
      }

      mapRef.current.on('zoomend', handler)

      return () => {
        mapRef.current?.off('zoomend', handler)
      }
    }

    return () => undefined
  }, [onZoom])

  useEffect(() => {
    if (onClick && mapRef.current) {
      mapRef.current.on('click', onClick)

      return () => {
        mapRef.current?.off('click', onClick)
      }
    }

    return () => undefined
  }, [onClick])
}

export default useEvents
